import { MATH_HELPER } from './maths'
import { DATE_HELPER } from './dates'
import { LOGIC_HELPER } from './logic'
import { TEXT_HELPER } from './text'
const getOptionsList = (list) =>
  Object.keys(list).map((item) => ({
    key: item,
    ...list[item]
  }))
export const functionOptions = [
  {
    module: '逻辑函数',
    shortTitle: '逻辑',
    key: 'logic',
    lists: getOptionsList(LOGIC_HELPER)
  },
  {
    module: '数学函数',
    shortTitle: '数学',
    key: 'maths',
    lists: getOptionsList(MATH_HELPER)
  },
  {
    module: '日期函数',
    shortTitle: '日期',
    key: 'dates',
    lists: getOptionsList(DATE_HELPER)
  },
  {
    module: '文本函数',
    shortTitle: '文本',
    key: 'text',
    lists: getOptionsList(TEXT_HELPER)
  }
]
